import React from 'react';

const LocalizationContext = React.createContext({});

const LocalizationContextProvider = (props) => {
    return (
        <LocalizationContext.Provider value={props.siteContext}>
            {props.children}
        </LocalizationContext.Provider>
    );
};

export {LocalizationContext, LocalizationContextProvider};
